<div class="page-container third-party-service-page" testId="third-party-service-page">
  <div class="page-topbar" testId="third-party-service-topbar">
    <div class="page-header" testId="third-party-service-header">
      <div class="page-heading" testId="third-party-service-heading">
        <h2 testId="third-party-service-title">{{ 'tenant.third-party-service.title' | i18n }}</h2>
        <p testId="third-party-service-subtitle">{{ 'tenant.third-party-service.subtitle' | i18n }}</p>
      </div>
      <div class="page-actions" testId="third-party-service-actions">
        <button
          nz-button
          nzType="default"
          type="button"
          class="refresh-btn"
          (click)="loadServers()"
          testId="third-party-service-refresh-button"
        >
          <i nz-icon nzType="reload"></i>
          {{ 'common.refresh' | i18n }}
        </button>
        <button
          nz-button
          nzType="primary"
          type="button"
          class="create-btn"
          (click)="openCreateModal()"
          testId="third-party-service-create-button"
        >
          <i nz-icon nzType="plus"></i>
          {{ 'tenant.third-party-service.create' | i18n }}
        </button>
      </div>
    </div>

    <div class="topbar-search" testId="third-party-service-search-section">
      <div class="topbar-search-row" testId="third-party-service-search-row">
        <nz-input-group nzPrefixIcon="search" class="search-input" testId="third-party-service-search-input-group">
          <input
            nz-input
            [value]="keyword()"
            (input)="updateKeyword($any($event.target).value)"
            [placeholder]="'tenant.third-party-service.search.placeholder' | i18n"
            testId="third-party-service-search-input"
          />
        </nz-input-group>
      </div>
    </div>
  </div>

  <div class="page-scroll" #pageScrollContainer (scroll)="onPageScroll($event)" testId="third-party-service-page-scroll">
    <nz-alert nzType="info" [nzMessage]="'tenant.third-party-service.tip' | i18n" nzShowIcon testId="third-party-service-tip" />

    <div class="content-section" testId="third-party-service-content">
      <nz-card class="table-card" testId="third-party-service-table-card">
        <nz-spin [nzSpinning]="loading()" testId="third-party-service-table-spin">
          <div class="table-section" #tableSectionContainer testId="third-party-service-table-section">
            <ng-container *ngIf="filteredServers().length; else emptyState">
              <nz-table
                class="table-container"
                nzSize="middle"
                [nzData]="filteredServers()"
                [nzFrontPagination]="false"
                [nzShowPagination]="false"
                [nzScroll]="{ x: '1180px', y: '100%' }"
                testId="third-party-service-table"
              >
                <thead>
                  <tr>
                    <th nzWidth="220px">{{ 'tenant.third-party-service.columns.name' | i18n }}</th>
                    <th nzWidth="280px">{{ 'tenant.third-party-service.columns.webhook' | i18n }}</th>
                    <th nzWidth="170px">{{ 'tenant.third-party-service.columns.binding-count' | i18n }}</th>
                    <th nzWidth="220px">{{ 'tenant.third-party-service.columns.updated-at' | i18n }}</th>
                    <th nzWidth="290px" class="actions-col">{{ 'common.action' | i18n }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of filteredServers(); let i = index" [testId]="'third-party-service-table-row-' + i">
                    <td>
                      <div class="server-name">{{ item.name }}</div>
                      <div class="server-desc" *ngIf="item.description">{{ item.description }}</div>
                    </td>
                    <td class="mono">{{ item.webhookUrl }}</td>
                    <td>{{ item.relatedServiceNumberCount }}</td>
                    <td>{{ item.updatedAt }}</td>
                    <td class="actions-col">
                      <div class="actions">
                        <button
                          nz-button
                          nzType="default"
                          type="button"
                          class="action-btn action-btn-view"
                          [disabled]="!item.secret"
                          (click)="viewSecret(item)"
                          [testId]="'third-party-service-view-secret-button-' + i"
                        >
                          <i nz-icon nzType="eye"></i>
                          {{ 'tenant.third-party-service.secret.view' | i18n }}
                        </button>
                        <button
                          nz-button
                          nzType="default"
                          type="button"
                          class="action-btn action-btn-edit"
                          (click)="openEditModal(item)"
                          [testId]="'third-party-service-edit-button-' + i"
                        >
                          <i nz-icon nzType="edit"></i>
                          {{ 'common.edit' | i18n }}
                        </button>
                        <button
                          nz-button
                          nzDanger
                          type="button"
                          class="action-btn action-btn-delete"
                          (click)="deleteServer(item)"
                          [testId]="'third-party-service-delete-button-' + i"
                        >
                          <i nz-icon nzType="delete"></i>
                          {{ 'common.delete' | i18n }}
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
            </ng-container>
          </div>
        </nz-spin>
      </nz-card>
      <div class="load-more-indicator" *ngIf="loadingMore()" testId="third-party-service-loading-more">
        <nz-spin nzSize="small" />
      </div>
    </div>
  </div>
</div>

<ng-template #emptyState>
  <nz-empty [nzNotFoundContent]="'tenant.third-party-service.empty' | i18n" testId="third-party-service-empty" />
</ng-template>

<nz-modal
  nzClassName="third-party-server-modal"
  nzWrapClassName="third-party-server-modal-wrap"
  [nzVisible]="modalVisible()"
  [nzTitle]="(editingServerId() ? 'common.edit' : 'tenant.third-party-service.create') | i18n"
  [nzOkLoading]="saving()"
  [nzOkText]="'common.save' | i18n"
  [nzCancelText]="'common.cancel' | i18n"
  (nzOnCancel)="closeModal()"
  (nzOnOk)="saveServer()"
  testId="third-party-service-form-modal"
>
  <ng-container *nzModalContent>
    <form nz-form nzLayout="vertical" [formGroup]="serverForm" testId="third-party-service-form">
      <nz-form-item>
        <nz-form-label nzRequired>{{ 'tenant.third-party-service.form.name' | i18n }}</nz-form-label>
        <nz-form-control [nzErrorTip]="'tenant.third-party-service.form.name-required' | i18n">
          <input
            nz-input
            formControlName="name"
            [placeholder]="'tenant.third-party-service.form.name-placeholder' | i18n"
            testId="third-party-service-name-input"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>{{ 'tenant.third-party-service.form.webhook' | i18n }}</nz-form-label>
        <nz-form-control [nzErrorTip]="'tenant.third-party-service.form.webhook-required' | i18n">
          <input
            nz-input
            formControlName="webhookUrl"
            [placeholder]="'tenant.third-party-service.form.webhook-placeholder' | i18n"
            testId="third-party-service-webhook-input"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>{{ 'common.description' | i18n }}</nz-form-label>
        <nz-form-control>
          <textarea
            nz-input
            formControlName="description"
            [nzAutosize]="{ minRows: 3, maxRows: 5 }"
            [placeholder]="'common.description-placeholder' | i18n"
            testId="third-party-service-description-textarea"
          ></textarea>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>

<nz-modal
  nzClassName="third-party-secret-modal"
  nzWrapClassName="third-party-secret-modal-wrap"
  [nzVisible]="secretVisible()"
  [nzFooter]="null"
  [nzTitle]="'tenant.third-party-service.secret.modal-title' | i18n"
  (nzOnCancel)="closeSecretModal()"
  testId="third-party-service-secret-modal"
>
  <ng-container *nzModalContent>
    <nz-alert nzType="warning" nzShowIcon [nzMessage]="secretHintKey() | i18n" />
    <div class="secret-meta" *ngIf="secretAppId()">
      <span class="secret-meta-label">{{ 'tenant.third-party-service.secret.field.app-id' | i18n }}</span>
      <span class="secret-meta-value mono">{{ secretAppId() }}</span>
    </div>
    <div class="secret-box">
      <div class="secret-box-header">
        <span>{{ 'tenant.third-party-service.secret.field.secret' | i18n }}</span>
        <button
          nz-button
          nzType="default"
          type="button"
          class="secret-copy-btn"
          (click)="copySecret()"
          testId="tenant-third-party-secret-header-copy-button"
        >
          <i nz-icon nzType="copy"></i>
          {{ 'tenant.third-party-service.secret.copy' | i18n }}
        </button>
      </div>
      <div class="secret-box-value">{{ secretValue() }}</div>
    </div>
    <div class="secret-actions">
      <button nz-button nzType="default" type="button" (click)="copySecret()" testId="tenant-third-party-secret-footer-copy-button">
        {{ 'tenant.third-party-service.secret.copy' | i18n }}
      </button>
      <button nz-button nzType="primary" type="button" (click)="closeSecretModal()" testId="tenant-third-party-secret-close-button">{{
        'common.close' | i18n
      }}</button>
    </div>
  </ng-container>
</nz-modal>
